import React, { useState } from 'react';
import { Modal, Tab, Tabs } from 'react-bootstrap';
import { useAppDispatch } from '../../store/store';
import { ImageModalTabKey } from '../../interfaces/common.interface';
import AssetsImages from './AssetsImages';
import UnsplashImages from './UnsplashImages';

interface IProps {
    show: boolean;
    onHide: () => void;
    onUpload: (imageUrl: string) => void;
}

const ImageModal = ({ show, onHide, onUpload }: IProps) => {
    const dispatch = useAppDispatch();

    const [activeTab, setActiveTab] = useState(ImageModalTabKey.ASSETS);

    return (
        <Modal show={show} centered backdrop="static" onHide={onHide}>
            <Modal.Header closeButton>
                <Modal.Title>Product Photography Image</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Tabs
                    defaultActiveKey={ImageModalTabKey.ASSETS}
                    id="controlled-tab-example"
                    className="tabs"
                    activeKey={activeTab}
                    onSelect={(key) => setActiveTab(key as ImageModalTabKey)}
                >
                    <Tab
                        eventKey={ImageModalTabKey.ASSETS}
                        title="From Assets"
                        className="tabs-button"
                    >
                        <AssetsImages show={show} onHide={onHide} onUpload={onUpload} />
                    </Tab>
                    <Tab
                        eventKey={ImageModalTabKey.UNSPLASH}
                        title="From Unsplash"
                        className="tabs-button"
                    >
                        <UnsplashImages
                            show={show}
                            onHide={onHide}
                            activeTab={activeTab}
                            onUpload={onUpload}
                        />
                    </Tab>
                </Tabs>
            </Modal.Body>
        </Modal>
    );
};

export default ImageModal;
